// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1TfjO","balanceDisclaimer":"posDashboard_balanceDisclaimer__1LqsB"};